import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getFilteredUsersFromProjectMembersForTaskUserSelector } from "~/store/selectors/selector.users.jsx";
import { AssigneePicker } from "./AssigneePicker/index.jsx";

export const ProjectMembersAssigneePicker = ({ projectId, position, hiddenFromClient, ...rest }) => {
  const options = useSelector((state) => {
    return getFilteredUsersFromProjectMembersForTaskUserSelector(state, projectId, hiddenFromClient);
  });

  return (
    <AssigneePicker
      {...rest}
      options={options}
      position={position}
    />
  );
};

ProjectMembersAssigneePicker.propTypes = {
  projectId: PropTypes.number.isRequired,
  position: PropTypes.string,
  hiddenFromClient: PropTypes.bool,
};
